import SurveyListContainer from "./SurveyListContainer";
export default SurveyListContainer;



// WEBPACK FOOTER //
// src/components/survey/gestion/SurveyList/index.js